import state from '@/stores/case_templates/state.js'
import mutations from '@/stores/case_templates/mutations.js'
import actions from '@/stores/case_templates/actions.js'

export default {
  state,
  mutations,
  actions
}
